import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Winelist = /*#__PURE__*/function () {
  function Winelist(config, axios) {
    _classCallCheck(this, Winelist);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(Winelist, [{
    key: "guestAuthentication",
    value: function () {
      var _guestAuthentication = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userDetailsPayload) {
        var commonQueryParams, locale, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context.next = 4;
                return this.axios.post(this.config.postfix.GUEST_AUTHENTICATION, userDetailsPayload, {
                  params: {
                    locale: locale,
                    conceptCode: "CG",
                    enviroment: "stg1",
                    commonCert: "true",
                    upgradeCommonCert: "false"
                  }
                });

              case 4:
                response = _context.sent;

                if (!response) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

              case 7:
                return _context.abrupt("return", null);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function guestAuthentication(_x) {
        return _guestAuthentication.apply(this, arguments);
      }

      return guestAuthentication;
    }()
  }, {
    key: "addWineToLocker",
    value: function () {
      var _addWineToLocker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload, guestToken) {
        var commonQueryParams, locale, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context2.next = 4;
                return this.axios.post(this.config.postfix.ADD_WINE_TO_LOCKER, payload, {
                  headers: {
                    userToken: guestToken
                  },
                  params: {
                    locale: locale,
                    conceptCode: "CG",
                    enviroment: "stg1",
                    commonCert: "true",
                    upgradeCommonCert: "false",
                    lockerWineID: payload.venueWineID
                  }
                });

              case 4:
                response = _context2.sent;

                if (!response) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", response.data);

              case 7:
                return _context2.abrupt("return", null);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addWineToLocker(_x2, _x3) {
        return _addWineToLocker.apply(this, arguments);
      }

      return addWineToLocker;
    }()
  }, {
    key: "addKeyholder",
    value: function () {
      var _addKeyholder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload, guestToken) {
        var commonQueryParams, locale, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context3.next = 4;
                return this.axios.put(this.config.postfix.ADD_KEYHOLDER, payload, {
                  headers: {
                    userToken: guestToken
                  },
                  params: {
                    locale: locale,
                    conceptCode: "CG",
                    enviroment: "stg1",
                    commonCert: "true",
                    upgradeCommonCert: "false",
                    lockerWineID: payload.venueWineID
                  }
                });

              case 4:
                response = _context3.sent;

                if (!response) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", response.data);

              case 7:
                return _context3.abrupt("return", null);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function addKeyholder(_x4, _x5) {
        return _addKeyholder.apply(this, arguments);
      }

      return addKeyholder;
    }()
  }, {
    key: "removeKeyholder",
    value: function () {
      var _removeKeyholder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload, guestToken) {
        var commonQueryParams, locale, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context4.next = 4;
                return this.axios.put(this.config.postfix.REMOVE_KEYHOLDER, payload, {
                  headers: {
                    userToken: guestToken
                  },
                  params: {
                    locale: locale,
                    conceptCode: "CG",
                    enviroment: "stg1",
                    commonCert: "true",
                    upgradeCommonCert: "false",
                    lockerWineID: payload.venueWineID
                  }
                });

              case 4:
                response = _context4.sent;

                if (!response) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return", response.data);

              case 7:
                return _context4.abrupt("return", null);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function removeKeyholder(_x6, _x7) {
        return _removeKeyholder.apply(this, arguments);
      }

      return removeKeyholder;
    }()
  }, {
    key: "getWineLockerDetails",
    value: function () {
      var _getWineLockerDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(lockerID, guestToken) {
        var commonQueryParams, locale, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context5.next = 4;
                return this.axios.get(this.config.postfix.WINE_LOCKER_DETAILS, {
                  headers: {
                    userToken: guestToken
                  },
                  params: {
                    lockerID: lockerID,
                    locale: locale,
                    conceptCode: "CG",
                    enviroment: "stg1",
                    commonCert: "true",
                    upgradeCommonCert: "false",
                    populateWines: "yes"
                  }
                });

              case 4:
                response = _context5.sent;

                if (!response) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", response.data);

              case 7:
                return _context5.abrupt("return", null);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getWineLockerDetails(_x8, _x9) {
        return _getWineLockerDetails.apply(this, arguments);
      }

      return getWineLockerDetails;
    }()
  }, {
    key: "getLockersByLocation",
    value: function () {
      var _getLockersByLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(lockersByLocationPayload) {
        var commonQueryParams, locale, response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context6.next = 4;
                return this.axios.post(this.config.postfix.WINE_LOCKERS_BY_LOCATION, lockersByLocationPayload, {
                  headers: {
                    customTimeout: 40000
                  },
                  params: {
                    conceptCode: "CG",
                    locale: locale,
                    upgradeCommonCert: "false",
                    commonCert: "true",
                    environment: "stg1"
                  }
                });

              case 4:
                response = _context6.sent;

                if (!response) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt("return", response.data);

              case 7:
                return _context6.abrupt("return", null);

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getLockersByLocation(_x10) {
        return _getLockersByLocation.apply(this, arguments);
      }

      return getLockersByLocation;
    }()
  }, {
    key: "getLockersByOwner",
    value: function () {
      var _getLockersByOwner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(lockerOwnerID, guestToken) {
        var commonQueryParams, locale, response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context7.next = 4;
                return this.axios.post(this.config.postfix.WINE_LOCKERS_BY_OWNER, {
                  lockerOwnerID: lockerOwnerID
                }, {
                  headers: {
                    userToken: guestToken,
                    customTimeout: 40000
                  },
                  params: {
                    locale: locale,
                    conceptCode: "CG",
                    enviroment: "stg1",
                    commonCert: "true",
                    upgradeCommonCert: "false"
                  }
                });

              case 4:
                response = _context7.sent;

                if (!response) {
                  _context7.next = 7;
                  break;
                }

                return _context7.abrupt("return", response.data);

              case 7:
                return _context7.abrupt("return", null);

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getLockersByOwner(_x11, _x12) {
        return _getLockersByOwner.apply(this, arguments);
      }

      return getLockersByOwner;
    }()
  }, {
    key: "createGift",
    value: function () {
      var _createGift = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(giftDetails, guestToken) {
        var commonQueryParams, locale, response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context8.next = 4;
                return this.axios.post(this.config.postfix.WINE_LOCKERS_CREATE_GIFT, _objectSpread({}, giftDetails), {
                  // keeping this here as hardcoded but not able to use it as we already have autorization interceptor in index.native file.
                  headers: {
                    userToken: guestToken
                  },
                  params: {
                    locale: locale,
                    conceptCode: "CG",
                    enviroment: "stg1"
                  }
                });

              case 4:
                response = _context8.sent;

                if (!response) {
                  _context8.next = 7;
                  break;
                }

                return _context8.abrupt("return", response.data);

              case 7:
                return _context8.abrupt("return", null);

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function createGift(_x13, _x14) {
        return _createGift.apply(this, arguments);
      }

      return createGift;
    }()
  }, {
    key: "changeLockerVisibility",
    value: function () {
      var _changeLockerVisibility = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(lockerID, visibility, guestToken) {
        var commonQueryParams, locale, response;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context9.next = 4;
                return this.axios.put(this.config.postfix.WINE_LOCKER_CHANGE_VISIBILITY, {
                  lockerID: lockerID,
                  visibility: visibility
                }, {
                  headers: {
                    userToken: guestToken
                  },
                  params: {
                    locale: locale,
                    conceptCode: "CG",
                    enviroment: "stg1",
                    commonCert: "true",
                    upgradeCommonCert: "false"
                  }
                });

              case 4:
                response = _context9.sent;

                if (!response) {
                  _context9.next = 7;
                  break;
                }

                return _context9.abrupt("return", response.data);

              case 7:
                return _context9.abrupt("return", null);

              case 8:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function changeLockerVisibility(_x15, _x16, _x17) {
        return _changeLockerVisibility.apply(this, arguments);
      }

      return changeLockerVisibility;
    }()
  }, {
    key: "getWineLockerHistory",
    value: function () {
      var _getWineLockerHistory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(lockerID, guestToken) {
        var commonQueryParams, locale, conceptCode, response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                conceptCode = this.config.getConceptCode();
                _context10.next = 5;
                return this.axios.get(this.config.postfix.WINE_LOCKER_HISTORY, {
                  headers: {
                    userToken: guestToken
                  },
                  params: {
                    lockerID: lockerID,
                    locale: locale,
                    conceptCode: conceptCode,
                    enviroment: "stg1",
                    commonCert: "true",
                    upgradeCommonCert: "false"
                  }
                });

              case 5:
                response = _context10.sent;

                if (!response) {
                  _context10.next = 8;
                  break;
                }

                return _context10.abrupt("return", response.data);

              case 8:
                return _context10.abrupt("return", null);

              case 9:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getWineLockerHistory(_x18, _x19) {
        return _getWineLockerHistory.apply(this, arguments);
      }

      return getWineLockerHistory;
    }()
  }, {
    key: "acceptGift",
    value: function () {
      var _acceptGift = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(giftID, isAccepted, guestToken) {
        var conceptCode, response;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                conceptCode = this.config.getConceptCode();
                _context11.next = 3;
                return this.axios.put(this.config.postfix.ACCEPT_GIFT, {
                  giftID: giftID,
                  isAccepted: isAccepted
                }, {
                  headers: {
                    userToken: guestToken
                  },
                  params: {
                    conceptCode: conceptCode,
                    commonCert: "true",
                    upgradeCommonCert: "false"
                  }
                });

              case 3:
                response = _context11.sent;

                if (!response) {
                  _context11.next = 6;
                  break;
                }

                return _context11.abrupt("return", response.data);

              case 6:
                return _context11.abrupt("return", null);

              case 7:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function acceptGift(_x20, _x21, _x22) {
        return _acceptGift.apply(this, arguments);
      }

      return acceptGift;
    }()
  }]);

  return Winelist;
}();

export { Winelist as default };